import Marquee from "react-fast-marquee";
import { TECH_STACK } from "../lib/content";

export const TechStack = () => {
  return (
    <section
      id="tecnologias"
      data-testid="techstack-section"
      className="bg-slate-900 text-white py-20 md:py-24 border-y border-white/10 relative overflow-hidden"
    >
      <div className="container mx-auto px-4 md:px-6 relative">
        <div className="max-w-3xl mb-10">
          <div className="font-mono text-xs uppercase tracking-[0.25em] text-orange-400 mb-4">
            <span>{`{ `}</span>stack<span>{` }`}</span>
          </div>
          <h2 className="font-display font-extrabold text-3xl md:text-5xl tracking-tight">
            Tecnologías con las que trabajamos.
          </h2>
          <p className="mt-4 text-slate-300">
            Elegimos herramientas probadas en producción. Te ayudamos a decidir qué encaja con
            tu equipo y roadmap.
          </p>
        </div>
      </div>

      <div className="relative">
        <Marquee gradient gradientColor="#0F172A" gradientWidth={80} speed={40} pauseOnHover>
          {TECH_STACK.map((t) => (
            <span
              key={t}
              data-testid={`tech-${t.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="mx-6 md:mx-10 font-mono font-semibold text-xl md:text-3xl text-slate-300 hover:text-orange-400 transition-colors"
            >
              {t}
              <span className="mx-4 md:mx-6 text-purple-500">·</span>
            </span>
          ))}
        </Marquee>
      </div>
    </section>
  );
};

export default TechStack;
